/**
 * Redireciona usuário integrador pra página 404
 *
 * Se o VExpenses não estiver carregado em um iframe e se
 * o usuário não for um usuário que representa a integração
 * utilizando iframe redireciona para a página 404, pois ele
 * não deve acessar o VExpenses dessa forma
 */
exports.init = function RedirectUserIntegration() {
  // Se o window for diferente ao window.parent indica que
  // foi carregado dentro de um iframe
  const isLoadedInIframe = (window !== window.parent);

  if (isLoadedInIframe) {
    return;
  }

  // Data que informa se o usuário utiliza integração com iframe
  const container = document
    .querySelector('#content-container');

  if (container) {
    const userIntegrationFromIframe = container.getAttribute('data-user-integration-iframe');
    // redirect no caso de que o usuario é de uma integração via iframe,
    // ou seja, ele só pode acessar pelo iframe
    if (userIntegrationFromIframe) {
      window.location.href = route('app.sair-usuario-integracao');
    }
  }
}
